<div class="whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
  @for (part of parts; track $index) {@if (part.workUrl) {
  <button
    type="button"
    class="my-1 block w-full min-w-0 max-w-[320px] rounded-lg text-left focus-visible:outline-primary disabled:opacity-60"
    [disabled]="!!opening"
    [attr.aria-busy]="opening === part"
    (click)="open(part)"
  >
    @if (part.preview) {
    <app-public-work-preview [data]="part.preview" />
    } @else {
    <span
      class="block py-1 font-bold underline text-primary-text dark:text-primary"
      >{{ part.text }}</span
    >
    }
  </button>
  } @else if (part.href) {<a
    class="font-bold underline text-primary dark:text-primary"
    [href]="part.href"
    [title]="part.href"
    target="_blank"
    rel="noopener noreferrer"
    >{{ part.text }}</a
  >} @else {{{ part.text }}}}
</div>
@if (opening) {
<p class="!my-0.5 text-xs" role="status">{{ "LOADING" | translate }}</p>
} @if (error) {
<p
  class="!my-0.5 text-xs text-form-error dark:text-form-errorLight"
  role="alert"
>
  {{ error | translate }}
</p>
}
